import { isHeldSubscriptionStatus } from "../model/constants"
import type { HeldSubscription, Subscription } from "../model/types"

/** Narrows to a plan the viewer still holds, so a cancel action is only ever offered for one of those. */
export const isHeldSubscription = (subscription: Subscription | null | undefined): subscription is HeldSubscription =>
  subscription !== null && subscription !== undefined && isHeldSubscriptionStatus(subscription.status)
